var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSliderChevron(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 30",
    style: {
      enableBackground: "new 0 0 12 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C6D7EA;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D---Dashboard_Menu_collapsed-Copy-2",
    transform: "translate(-24.000000, -525.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SliderChevron"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,554.8c-0.2,0-0.3,0-0.4-0.1c-0.3-0.2-0.4-0.7-0.2-1l9.7-13.5l-9.7-13.7c-0.2-0.3-0.2-0.8,0.2-1 c0.3-0.2,0.8-0.2,1,0.2l10,14.1c0.2,0.3,0.2,0.6,0,0.9l-10,13.9C25.5,554.6,25.2,554.8,25,554.8z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderChevron);
export default __webpack_public_path__ + "static/media/slider-chevron.7c35dd5d333f260c3b23635dd279b0f2.svg";
export { ForwardRef as ReactComponent };